import * as formValidators from '@Framework/components/form/validators';
export default { ...formValidators };
